export const Cohort = {
	NOT_ENROLLED: 'not-enrolled',
	CONTROL: 'control',
	TREATMENT: 'treatment',
};
